import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";

export default function CategorySection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按心情挑一个话题分类
          </h2>
          <p className="mt-2 text-sm leading-7 text-foreground-600">
            想看节目动态、突发热点，还是单纯想围观观点对撞，分类帮你快速定位。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/topics?category=${cat.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{cat.desc}</p>
              <span className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span>{cat.count} 个话题</span>
                <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}